import C from "@/utils/constants.js";

export default {
  drawer: (state) => state.drawer,
  responsive: (state) => state.responsive,
  me: (state) => state.me,
  myAgentsCount: (state) => state.myAgentsCount,
  myAgentsSort: (state) => state.myAgentsSort,
  myAgentsSortDesc: (state) => state.myAgentSortDesc,
  myBrokerage: (state) => state.myBrokerage,
  myLoanOffice: (state) => state.myLoanOffice,
  agent: (state) => state.agent,
  isLoadingMe: (state) => state.isLoadingMe,
  roles: (state) => {
    console.log("Calling user/roles");

    console.log("me...");
    console.log(state.me);

    if (state.me && state.me.roles) {
      return state.me.roles.map((role) => {
        return role.name;
      });
    }

    return [];
  },
  isPrimestreetRoleType: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].type === C.ROLE_TYPE.PRIMESTREET_ROLE) {
          return true;
        }
      }
    }
    return false;
  },
  isAdmin: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.RoleAdmin) {
          return true;
        }
      }
    }
    return false;
  },
  isBrokerAdmin: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.RoleBrokerAdmin) {
          return true;
        }
      }
    }
    return false;
  },
  isLoanOfficer: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.ROLE.LOAN_OFFICE_ADMIN) {
          return true;
        }
      }
    }
    return false;
  },
  isAgentEngagement: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.ROLE.AGENT_ENGAGEMENT) {
          return true;
        }
      }
    }
    return false;
  },
  isLeadSupplier: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.ROLE.LEAD_SUPPLIER) {
          return true;
        }
      }
    }
    return false;
  },
  isAgent: (state) => {
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        if (state.me.roles[i].name === C.ROLE.AGENT) {
          return true;
        }
      }
    }
    return false;
  },
  isAgentOnly: (state) => {
    if (state.me && state.me.roles && state.me.roles.length > 0) {
      if (state.me.roles.length > 1) {
        return false;
      }

      return state.me.roles[0].name === C.ROLE.AGENT;
    }
    return false;
  },
  isCSRViewOppOnly: (state) => {
    let isCSRViewOpp = false;
    let isOppRole = false;
    if (state.me && state.me.roles) {
      for (let i = 0; i < state.me.roles.length; i++) {
        const role = state.me.roles[i].name;
        if (role === C.ROLE.CSR_VIEW_OPPORTUNITIES) {
          isCSRViewOpp = true;
        }

        // check for any other opp allowed roles
        if (
          role === C.ROLE.ADMIN ||
          role === C.ROLE.CSR_SUPERVISOR ||
          role === C.ROLE.AGENT_ENGAGEMENT ||
          role === C.ROLE.MANAGER ||
          role === C.ROLE.QA_TEAM
        ) {
          isOppRole = true;
        }
      }
    }

    return isCSRViewOpp && !isOppRole;
  },
  mobileBrokerSort: (state) => state.mobileBrokerSort,
  mobileAgentSort: (state) => state.mobileAgentSort,
  mobileBrokerSearch: (state) => state.mobileBrokerSearch,
  mobileAgentSearch: (state) => state.mobileAgentSearch,
  agentDetailsActiveTab: (state) => state.agentDetailsActiveTab,
  // getter that allows passing of product param as a string to check if array contains that product
  brokerageHasProduct: (state) => (product) => {
    if (state.myBrokerage?.product) {
      return state.myBrokerage.product.some((p) => p.productFamily === product);
    }
    return false;
  },
  brokerBoostStatus: (state) => state.brokerBoostStatus,
  userType: (state) => state.userType,
};
